import React from 'react';
import { Box } from '@mui/material';

const InteractiveCube = ({ size = 60, color = "#ff4d4d", delay = 0 }) => {
    return (
        <Box
            sx={{
                position: 'relative',
                width: size,
                height: size,
                animation: `rotate3d 8s linear ${delay}s infinite`,
                '&:hover': {
                    animationPlayState: 'paused',
                    transform: 'scale(1.1)',
                },
                transition: 'transform 0.3s ease',
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    background: `linear-gradient(135deg, ${color}40, ${color}80)`,
                    border: `2px solid ${color}`,
                    borderRadius: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.7rem',
                    color: 'white',
                    fontWeight: 'bold',
                    boxShadow: `0 0 20px ${color}80`,
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: '10%',
                        left: '10%',
                        right: '10%',
                        bottom: '10%',
                        border: `1px solid ${color}60`,
                        borderRadius: '6px',
                    },
                }}
            />
        </Box>
    );
};

export default InteractiveCube;